import { defineComponent as p, openBlock as r, createBlock as u, Transition as g, unref as o, withCtx as h, createElementVNode as s, normalizeClass as n, createElementBlock as i, renderSlot as m, withDirectives as l, vShow as a, createCommentVNode as c, createTextVNode as y, toDisplayString as k } from "vue";
import { useNamespace as _ } from "../../hooks/use-namespace.js";
import "../../hooks/use-z-index.js";
import { alertEmits as v, alertProps as w } from "./alert.js";
import "./alert.css";
const C = { src: "https://img66.anypromo.com/frontimg/2019/Icon/tips-2.png" }, N = { src: "https://img66.anypromo.com/frontimg/2019/Icon/okay-2.png" }, $ = p({
  name: "ApAlert"
}), D = /* @__PURE__ */ p({
  ...$,
  props: w,
  emits: v,
  setup(f, { emit: B }) {
    const d = f, t = _("alert");
    return (e, E) => (r(), u(g, {
      name: o(t).b("fade")
    }, {
      default: h(() => [
        s("div", {
          class: n([o(t).b(), o(t).m(e.type), o(t).is(e.effect)])
        }, [
          e.$slots.icon || d.showIcon ? (r(), i("i", {
            key: 0,
            class: n(o(t).e("icon"))
          }, [
            m(e.$slots, "icon", {}, () => [
              l(s("img", C, null, 512), [
                [a, e.type === "error"]
              ]),
              l(s("img", N, null, 512), [
                [a, e.type === "success"]
              ])
            ])
          ], 2)) : c("", !0),
          s("div", {
            class: n(o(t).e("content"))
          }, [
            e.title || e.$slots.title ? (r(), i("span", {
              key: 0,
              class: n([o(t).e("title")])
            }, [
              m(e.$slots, "title", {}, () => [
                y(k(e.title), 1)
              ])
            ], 2)) : c("", !0)
          ], 2)
        ], 2)
      ]),
      _: 3
    }, 8, ["name"]));
  }
});
export {
  D as default
};
